<template>

<div class="d-flex justify-content-center align-items-center" style="height: 80vh;">
  <b-card no-body header="Iniciar Sesión" header-bg-variant="primary" header-text-variant="light" class="login-card">
    <div class="card-body d-flex">
      <form @submit.prevent="logIn" action="#" class="flex-grow-1 d-flex flex-column justify-content-between">
        <div>
          <icon-input v-model="username" :disabled="loading" label="Usuario" icon="user"/>
          <icon-input v-model="password" :disabled="loading" type="password" label="Contraseña" icon="key"/>
        </div>
        <fa-icon v-show="loading" icon="spinner" pulse size="2x" class="mx-auto"/>
        <b-button type=submit variant="primary" :disabled="loading">Iniciar Sesión</b-button>
      </form>
    </div>
  </b-card>
</div>

</template>

<script>

import IconInput from '@/components/common/IconInput'

export default {
  name: 'Login',
  components: {IconInput},
  data() {
    return {
      loading: false,
      username: '',
      password: ''
    }
  },
  methods: {
    logIn() {
      this.loading = true

      this.$auth.logIn(this.username, this.password).then(() => {
        this.$router.push({name: 'WorkOrderIndex'})
      }).catch(error => {
        if (error.response.status === 400 || error.response.status === 401) {
          this.$toastr('error', 'Usuario o contraseña incorrectos')
          this.password = ''
        }
      }).finally(() => { this.loading = false })
    }
  }
}

</script>

<style lang="scss">

.login-card {
  width: 400px;
  height: 350px;
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue